import { CommonUtility } from '../common';
import { APIPath } from '../constants';
import { BaseService } from './base';
import { CRUDService } from './crud.ts';

class Items extends CRUDService {
  constructor() {
    super(APIPath.items);
  }

  updateIdentifiers(itemId, data) {
    return BaseService.put(`${APIPath.items}/${itemId}/barcodeIdentifiers`, data);
  }

  getRestockThreshold(itemId, warehouseId) {
    return BaseService.get(
      `${APIPath.items}/${itemId}/restockThreshold?${CommonUtility.objectToParams({
        warehouseId,
      })}`,
    );
  }

  updateRestockThreshold(itemId, data) {
    return BaseService.put(`${APIPath.items}/${itemId}/restockThreshold`, data);
  }

  exportItemLogs(itemId, params) {
    return BaseService.get(
      `${
        APIPath.inventoryItem
      }/${itemId}/history/export/?${CommonUtility.objectToParams(params)}`,
    );
  }
}

const ItemService = new Items();
Object.freeze(ItemService);
export { ItemService };
